import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import axios from 'axios'

const EditTable = props => {
  const {
    assistantList,
    lang,
    category,
    create,
    setCreate,
    getOnboarding,
    gender,
    langList,
  } = props

  const [data, setData] = useState(assistantList)
  const [checked, setChecked] = useState([])
  const [drag, setDrag] = useState(false)
  const [assistantId, setAssistantId] = useState('')
  const [copy, setCopy] = useState(false)
  const [selectedLang, setSelectedLang] = useState([])

  const dragDataInit = {
    target: null,
    index: -1,
    move_up: [],
    move_down: [],
    updateList: [],
  }

  const [dragData, setDragData] = useState(dragDataInit)
  const [isScroll, setIsScroll] = useState('')
  const [posY, setPosY] = useState(0)

  const checkRef = useRef([])
  const wrapperRef = useRef()

  useEffect(() => {
    if (checked.length === 0) {
      setCopy(false)
    }
  }, [checked])

  useEffect(() => {
    setAssistantId('')
  }, [create])

  useEffect(() => {
    setData(assistantList)
  }, [assistantList])

  useEffect(() => {
    const scrollHeight = wrapperRef.current.scrollTop
    const posH = wrapperRef.current.getBoundingClientRect().height

    if (isScroll === 'down') {
      wrapperRef.current.scrollTo({
        top: scrollHeight + posH - posY * 2,
        behavior: 'smooth',
      })
    }

    if (isScroll === 'up') {
      wrapperRef.current.scrollTo({
        top: scrollHeight - posH + posY * 2,
        behavior: 'smooth',
      })
    }
  }, [isScroll])

  useEffect(() => {
    setCopy(false)
    setCreate(false)
    setChecked([])
    checkRef.current.forEach((checkbox, index) => {
      if (checkbox) {
        checkbox.checked = false
      }
    })
  }, [lang, category, gender])

  useEffect(() => {
    setSelectedLang([])
  }, [copy])

  const handleCheck = e => {
    if (e.target.checked) {
      setChecked([...checked, e.target.value])
    } else {
      setChecked(checked.filter(c => c !== e.target.value))
    }
  }

  const handleCheckAll = () => {
    const allSeqs = data.map(item => String(item.seq))
    setChecked(allSeqs)

    checkRef.current.forEach((checkbox, index) => {
      if (checkbox) {
        checkbox.checked = true
      }
    })
  }

  const handleCheckAllCancel = () => {
    setChecked([])
    checkRef.current.forEach((checkbox, index) => {
      if (checkbox) {
        checkbox.checked = false
      }
    })
  }

  const reOrderPromise = async (seq, order) => {
    const params = {
      seq,
      order,
    }

    return new Promise(async (resolve, reject) => {
      await axios
        .put(`/new/webAdmin/v2/assistant/onboarding/order`, params, {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  const reOrder = async list => {
    const result = await Promise.all(
      list.map((item, index) => reOrderPromise(item.seq, index + 1))
    )

    if (result) {
      getOnboarding(lang, category, gender)
    }
  }

  const _dragStart = e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    setDragData({
      ...dragData,
      target: e.currentTarget,
      index: Number(e.currentTarget.dataset.index),
      updateList: [...data],
    })

    e.dataTransfer.setData('text/html', '')
    e.dataTransfer.effectAllowed = 'move'
  }

  const _dragEnter = e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    const _dragged = Number(dragData.target.dataset.index)
    const _target = Number(e.currentTarget.dataset.index)
    let move_down = [...dragData.move_down]
    let move_up = [...dragData.move_up]

    if (_dragged > _target) {
      if (move_down.includes(_target)) {
        move_down = move_down.slice(0, move_down.indexOf(_target))
      } else {
        move_down = Array(_dragged - _target)
          .fill()
          .map((v, i) => i + _target)
          .reverse()
      }
      move_up = []
    } else if (_dragged < _target) {
      if (move_up.includes(_target)) {
        move_up = move_up.slice(0, move_up.indexOf(_target))
      } else {
        move_up = Array(_target - _dragged)
          .fill()
          .map((v, i) => _target - i)
          .reverse()
      }
      move_down = []
    } else {
      move_down = []
      move_up = []
    }

    setDragData({
      ...dragData,
      // updateList: updateData,
      index: _target,
      move_up,
      move_down,
    })
  }

  const _dragLeave = e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    if (e.currentTarget === dragData.target) {
      e.currentTarget.style.visibility = 'hidden'
    }
  }

  const _dragEnd = e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    let updateData = [...dragData.updateList]

    const changeOrder = (i, t) => {
      const target = updateData.splice(i, 1)[0]
      updateData.splice(t, 0, target)
    }

    const _dragged = Number(e.currentTarget.dataset.index)
    let _target = Number(dragData.index)

    if (dragData.move_up.length > 0) {
      _target = dragData.move_up[dragData.move_up.length - 1]
    } else if (dragData.move_down.length > 0) {
      _target = dragData.move_down[dragData.move_down.length - 1]
    } else {
      _target = _dragged
    }

    changeOrder(_dragged, _target)

    setDrag(false)
    setData(updateData)
    reOrder(updateData)
    setDragData({
      ...dragData,
      move_down: [],
      move_up: [],
      updateList: [],
    })

    e.currentTarget.style.visibility = 'visible'
    e.dataTransfer.dropEffect = 'move'
  }

  const _dragCapture = async e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    const posH = e.target.getBoundingClientRect().height
    const bottom = wrapperRef.current.getBoundingClientRect().bottom
    const top = wrapperRef.current.getBoundingClientRect().top

    setPosY(posH)

    if (e.clientY && e.clientY > top && e.clientY < bottom) {
      if (bottom - e.clientY < 90) {
        setIsScroll('down')
      } else if (e.clientY - top < 90) {
        setIsScroll('up')
      } else {
        setIsScroll('')
      }
    }
  }

  const clickCreate = async () => {
    if (assistantId) {
      await axios
        .post(
          `/new/webAdmin/v2/assistant/onboarding`,
          {
            assistantId,
            lang,
            category,
          },
          {
            headers: {
              token: sessionStorage.getItem('token'),
            },
          }
        )
        .then(() => {
          setCreate(false)
          getOnboarding(lang, category, gender)
        })
    }
  }

  const clickDelete = async () => {
    if (checked.length > 0) {
      const params = {
        deleted: checked,
      }

      await axios
        .delete(`/new/webAdmin/v2/assistant/onboarding`, {
          headers: {
            token: sessionStorage.getItem('token'),
          },
          data: params,
        })
        .then(() => {
          if (checkRef.current) {
            checkRef.current.map(c => {
              if (c && c.checked) {
                c.checked = false
              }
            })
          }

          setChecked([])
          getOnboarding(lang, category, gender)
        })
    }
  }

  const clickCopy = async () => {
    if (checked.length > 0 && selectedLang.length > 0) {
      const params = {
        checked,
        selectedLang,
      }

      await axios
        .post(`/new/webAdmin/v2/assistant/onboarding/copy`, params, {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        })
        .then(() => {
          setCopy(false)
          handleCheckAllCancel()
          getOnboarding(lang, category, gender)
        })
    }
  }

  return (
    <Wrapper>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'absolute',
          bottom: '100%',
          right: 0,
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${Math.ceil(
              langList.length / 2
            )}, 1fr)`,
            gap: '4px',
            marginBottom: '10px',
          }}
        >
          {copy &&
            langList.map((l, i) => (
              <div
                key={i}
                style={{
                  padding: '0 5px',
                  backgroundColor: selectedLang.includes(l.code)
                    ? '#007ffb'
                    : '#fff',
                  borderRadius: '5px',
                  display: 'flex',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  color: selectedLang.includes(l.code) ? '#fff' : '#000',
                }}
                onClick={() => {
                  if (selectedLang.includes(l.code)) {
                    setSelectedLang(selectedLang.filter(s => s !== l.code))
                  } else {
                    setSelectedLang([...selectedLang, l.code])
                  }
                }}
              >
                {l.code}
              </div>
            ))}
        </div>
        <ButtonWrapper>
          {data.length > 0 && (
            <button
              style={{ backgroundColor: '#ff4500' }}
              onClick={() => {
                if (checked.length === data.length) {
                  handleCheckAllCancel()
                } else {
                  handleCheckAll()
                }
              }}
            >
              {checked.length === data.length ? '선택 해제' : '모두 선택'}
            </button>
          )}
          {checked.length > 0 && (
            <>
              {copy && (
                <button
                  style={{ backgroundColor: '#007ffb' }}
                  onClick={() => {
                    clickCopy()
                  }}
                >
                  복제
                </button>
              )}
              <button
                style={{ backgroundColor: '#007ffb' }}
                onClick={() => {
                  setCopy(!copy)
                }}
              >
                {copy ? '취소' : '선택 복제'}
              </button>
              {!copy && (
                <button
                  style={{ backgroundColor: '#dc143c' }}
                  onClick={() => {
                    clickDelete()
                  }}
                >
                  선택 삭제
                </button>
              )}
            </>
          )}
        </ButtonWrapper>
      </div>
      <CollectionWrapper ref={wrapperRef}>
        {create ? (
          <CollectionItem>
            <Title>Assistant ID</Title>
            <TitleInput
              type={'text'}
              value={assistantId}
              onChange={e => {
                setAssistantId(e.target.value)
              }}
            />
            <button
              style={{ backgroundColor: '#007ffb', border: 'none' }}
              onClick={() => {
                clickCreate()
              }}
            >
              온보딩 추가
            </button>
            <button
              style={{ backgroundColor: '#dc143c', border: 'none' }}
              onClick={() => {
                setCreate(false)
              }}
            >
              취소
            </button>
          </CollectionItem>
        ) : (
          <CollectionItem
            onClick={() => {
              setCreate(true)
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '32px',
              cursor: 'pointer',
            }}
          >
            +
          </CollectionItem>
        )}
        {data.length > 0 &&
          data.map((item, index) => {
            let default_class = ''
            dragData.move_down.includes(index) && (default_class = 'move_down')
            dragData.move_up.includes(index) && (default_class = 'move_up')
            return (
              <CollectionItem
                key={index}
                data={item}
                data-index={index}
                draggable={drag}
                onDragStart={_dragStart}
                onDragEnter={_dragEnter}
                onDragLeave={_dragLeave}
                onDragEnd={_dragEnd}
                onDragCapture={_dragCapture}
                className={default_class}
              >
                <div style={{ width: '5%' }}>
                  <input
                    ref={el => (checkRef.current[index] = el)}
                    type="checkbox"
                    value={item.seq}
                    onChange={e => {
                      handleCheck(e)
                    }}
                  />
                </div>
                <div style={{ width: '10%' }}>#{index + 1}</div>
                <div
                  style={{
                    width: '15%',
                    minWidth: '80px',
                    marginRight: '5px',
                    justifyContent: 'flex-start',
                    fontWeight: 'bold',
                  }}
                >
                  {item.assistantProfileImg ? (
                    <img
                      src={item.assistantProfileImg}
                      alt=""
                      style={{ height: '100%' }}
                    />
                  ) : (
                    ''
                  )}
                </div>
                <div
                  style={{
                    width: '15%',
                    justifyContent: 'flex-start',
                    fontWeight: 'bold',
                  }}
                >
                  {item.assistantStatus === 'Y'
                    ? 'Public'
                    : item.assistantStatus === 'U'
                    ? 'Unlisted'
                    : 'Private'}
                </div>
                <div
                  style={{
                    width: '45%',
                    justifyContent: 'flex-start',
                    fontWeight: 'bold',
                  }}
                >
                  {item.assistantId !== 'null' ? item.assistantId : ''}
                </div>
                {gender !== 'all' && (
                  <div style={{ width: '15%', justifyContent: 'flex-end' }}>
                    <img
                      id="drag"
                      src="https://img.stipop.io/image/account/hamburger_menu.png"
                      alt=""
                      draggable={false}
                      onMouseDown={() => {
                        setDrag(true)
                      }}
                    />
                  </div>
                )}
              </CollectionItem>
            )
          })}
      </CollectionWrapper>
    </Wrapper>
  )
}

export default EditTable

const SpaceResponsive = styled.div`
  height: ${props => props.height}px;
  flex-shrink: 0;
`

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  position: relative;
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;

  button {
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-left: 10px;
    color: #fff;
    border-radius: 5px;
    border: none;

    &:hover {
      opacity: 0.8;
      font-weight: bold;
    }
  }
`

const CollectionWrapper = styled.div`
  width: 100%;
  height: calc(100dvh - 210px); /* 원하는 값으로 고정 */
  min-width: 400px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  row-gap: 10px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

const CollectionItem = styled.div`
  width: 100%;
  height: 80px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid ${props => (props.live ? '#007ffb' : '#000')};
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;
  opacity: 0.999;
  flex-shrink: 0;

  div {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #drag {
    width: 25px;
    height: 20px;
    cursor: pointer;
  }

  input[type='checkbox'] {
    width: 20px;
    height: 20px;
  }

  &.move_up {
    transform: translateY(-90px);
    z-index: 1;
  }
  &.move_down {
    transform: translateY(90px);
    z-index: 1;
  }
`

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  height: auto;
`

const TitleInput = styled.input`
  width: 100%;
  height: 30px;
`
